import { createAction } from '@reduxjs/toolkit'
import { all, call, ForkEffect, put, takeEvery } from 'redux-saga/effects'

import { unlinkGeometryFromFlag } from '../../../api/projects-api'
import managers from '../../lib/managers'
import { Flag, Workspace } from '../../lib/toolBoxes/2D'
import { unlinkFlagFromMaterial } from '../../slices/materialFlags'

export const unlinkGeometryFromFlagAction = createAction<{
    flag_id?: number
    opening_link_id?: number
    opening_id?: number | null
    openingIds?: number[]
}>('unlinkGeometryFromFlag')

export function* handleUnlinkGeometryFromFlag({ payload }: ReturnType<typeof unlinkGeometryFromFlagAction>) {
    try {
        const paperManager = yield call(managers.get2DManager)

        if (!paperManager) return

        const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

        const { flag_id, opening_link_id, opening_id, openingIds = [] } = payload

        const isSingleUnlink = opening_link_id !== undefined && opening_id !== undefined && flag_id !== undefined

        const flagItems: paper.Item[] = yield call(
            workspaceTool.getItemsWithCriteria,
            'data',
            isSingleUnlink
                ? (data) => data.flag_id === flag_id && data.openingId === opening_id && data.toolName === Flag.NAME
                : (data) =>
                      (data.flag_id === flag_id || openingIds.includes(data?.openingId)) && data.toolName === Flag.NAME
        )

        if (flagItems.length === 0) return

        if (opening_link_id !== undefined) {
            yield call(unlinkGeometryFromFlag, opening_link_id)
        } else if (flag_id) {
            const unlinkApiCalls = flagItems.map((item) => call(unlinkGeometryFromFlag, item.data.id))

            yield all(unlinkApiCalls)
        }

        const unlinkActions = flagItems.map((item) =>
            put(
                unlinkFlagFromMaterial({
                    flag_id: item.data.flag_id,
                    opening_link_id: item.data.openingId,
                })
            )
        )

        yield all(unlinkActions)
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForUnlinkGeometryFromFlag(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(unlinkGeometryFromFlagAction.type, handleUnlinkGeometryFromFlag)
}
